import { render } from "./ProfileEditProfileComponent.vue?vue&type=template&id=0ce65b74"
import script from "./ProfileEditProfileComponent.vue?vue&type=script&lang=js"
export * from "./ProfileEditProfileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/profile/ProfileEditProfileComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ce65b74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ce65b74', __exports__)) {
    api.reload('0ce65b74', __exports__)
  }
  
  module.hot.accept("./ProfileEditProfileComponent.vue?vue&type=template&id=0ce65b74", () => {
    api.rerender('0ce65b74', render)
  })

}


export default __exports__